/**
 * Block loader
 * 
 * Welcome to camelCase Anonymous.
 * 
 * Allows you to better separate JS files and only loads the script where its associated 
 * block is in use. Passes through the jQuery element to that JS script allowing the script
 * to run its magic on that object only.
 * 
 * Bases the block it is searching for on the page the script is under, and the script name
 * For example, the script loremIpsumDolor until partials.home will execute on any block
 * with the class home-lorem-ipsum-dolor
 * 
 * For consistency, this example block would be arranged as such:
 * => Blade: views/partials/home/lorem-ipsum-dolor.blade.php
 * => SCSS:  assets/styles/layouts/partials/home/_lorem-ipsum-dolor.scss
 * => JS:    assets/scripts/partials/home/loremIpsumDolor.js
 */

// Other partials which should always run
import banner from './other/banner';
import globalLightbox from './other/globalLightbox';
import navigation from './other/navigation';
import navigationMobile from './other/navigationMobile';
import footer from './other/footer';
import alert from './other/alert';
import globalSearch from './other/globalSearch';
import resourceLinks from './other/resourceLinks';
import defaultLinks from './other/defaultLinks';
import donations from './other/donations';

// Shared partials
import destinations from './shared/destinations';
import ctaScroller from './shared/ctaScroller';
import walkScroller from './shared/walkScroller';
import anchorLinks from './shared/anchorLinks';
import frequentlyAskedQuestions from './shared/frequentlyAskedQuestions';
import fullWidthGallery from './shared/fullWidthGallery';
import standardGallery from './shared/standardGallery';
import map from './shared/map';
import fullWidthBannerCta from './shared/fullWidthBannerCta';

// Home partials
import latestNews from './home/latestNews';
import walksOfTheMonth from './home/walksOfTheMonth';
import storiesScroller from './home/storiesScroller';
import statistics from './home/statistics';

// General partials
import leftRightContent from './general/leftRightContent';
import fullWidthVideo from './general/fullWidthVideo';
import threeColumnVideo from './general/threeColumnVideo';
import popQuote from './general/popQuote';
import textGrid from './general/textGrid';

// Walk Listing
import walkListingFilter from './walk-listing/walkListingFilter';

var partials = {
  shared: { destinations, ctaScroller, walkScroller, anchorLinks, frequentlyAskedQuestions, fullWidthGallery, standardGallery, map, fullWidthBannerCta },
  home: { latestNews, walksOfTheMonth, storiesScroller, statistics },
  general: { leftRightContent, fullWidthVideo, threeColumnVideo, popQuote, textGrid },
  walkListing: { walkListingFilter },
  other: { banner, globalLightbox, navigation, navigationMobile, footer, alert, globalSearch, resourceLinks, defaultLinks, donations },
};

export default {
  getPartialElement(script) {
    return String(script).replace(/([A-Z])/g, '-$1').toLowerCase();
  },
  getPageElement(page) {
    return page.replace(/([A-Z])/g, '-$1').toLowerCase();
  },
  init() {
    // Execute init function on all partials on the current page
    for (const page in partials) {
      for (const script in partials[page]) {
        const pageFriendly = this.getPageElement(page);
        if (page == 'other') {
          partials[page][script].init();
        } else {
          const element = this.getPartialElement(script);
          if ($(`.${pageFriendly}-${element}`).length > 0) {
            $(`.${pageFriendly}-${element}`).each(function() {
              partials[page][script].init($(this));
            });
          }
        }
      }
    }
  },
  finalize() {
    // Execute finalize function on all partials on the current page
    for (const page in partials) {
      for (const script in partials[page]) {
        const pageFriendly = this.getPageElement(page);
        if (page == 'other') {
          partials[page][script].finalize();
        } else {
          const element = this.getPartialElement(script);
          if ($(`.${pageFriendly}-${element}`).length > 0) {
            $(`.${pageFriendly}-${element}`).each(function() {
              partials[page][script].finalize($(this));
            });
          }
        }
      }
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/loader.js